import { apiClient } from '@/lib/api-client';
import type { Product } from '@/types/api';

/**
 * The published catalogue: products and the plans a customer can subscribe to.
 *
 * Split out of a file that also held the licence client. The catalogue was never a licensing
 * concern; it shared a file because licences used to be issued against plans, and when that
 * product was removed this was the only part worth keeping.
 */
export const catalogApi = {
  listProducts: () => apiClient.get<Product[]>('/catalog/products'),
  getProduct: (identifier: string) => apiClient.get<Product>(`/catalog/products/${identifier}`),
};
